import { createContext, useState, useContext, useEffect } from 'react'
import { useConfig } from './ConfigProvider'
import { ChangeCustOrderNumber, GetOrderItems, GetOrderFiltersData, GetWzDocFiltersData, GetOrderFromView } from '../Services/OrderService'
import { toast } from 'react-toastify'
import { useAuth } from './AuthProvider'
import { useDiscount } from './DiscountProvider'
import { useCart } from './CartProvider'


export const OrderContext = createContext()
export const useOrder = () => {
    return useContext(OrderContext)
}

export const OrderProvider = ({ children }) => {
    const { api } = useConfig()
    const { handleClearVoucher } = useDiscount()
    const { cartItems } = useCart()
    const { logout, authState } = useAuth()

    // Listy zamówień i dokumentów WZ obsługują teraz hooki useOrders/useWzDocs
    // (src/Hooks/Queries/useOrdersQueries.jsx) - tutaj zostaje stan formularza zamówienia.
    const [selectedOrderDetails, setSelectedOrderDetails] = useState(null)

    const [orderInfo, setOrderInfo] = useState({
        authorizedPersons: null,
        deliveryDate: null,
        deliveryType: null,
        deliveryAddress: null,
        payment: null,
        onlinePaymentSupplier: 'Elavon',
        comment: null,
        expectedDeliveryTime: null,
        isCustomDeliveryTime: false,
        attachments: [],
    })

    useEffect(() => {
        if (!cartItems || !cartItems.basketItems || cartItems.basketItems.length == 0) { //Czyszczenie orderInfo oraz voucher po wyczyszczeniu             
            clearOrderInfo()
            handleClearVoucher()
        }
    }, [cartItems])

    useEffect(() => {
        if (!authState.user || authState.selectedCustomer) { //Czyszczenie orderInfo oraz voucher po wylogowaniu lub zmianie kontrahenta przez ph            
            clearOrderInfo()
            handleClearVoucher()
        }
    }, [authState.user, authState.selectedCustomer])

    const clearOrderInfo = () => {
        setOrderInfo(prev => ({
            authorizedPersons: null,
            deliveryDate: null,
            deliveryType: null,
            deliveryAddress: null,
            payment: null,
            onlinePaymentSupplier: 'Elavon',
            comment: null,
            expectedDeliveryTime: null,
            isCustomDeliveryTime: false,
            //attachments: prev.attachments,
            attachments: [],
        }))
    }

    const changeCustOrderNumber = async (docNum, custDocNum, custId, siteId) => {
        try {
            const res = await ChangeCustOrderNumber(api, docNum, custDocNum, custId, siteId)
            return true
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto niekatywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            return false
        }
    }

    const handleGetOrderItems = async (orderNumber) => {
        try {
            const result = await GetOrderItems(api, orderNumber)
            return result.data
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto niekatywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            return []
        }
    }

    const handleGetOrderFiltersData = async (filters, cancelToken) => {
        try {
            const res = await GetOrderFiltersData(api, filters, cancelToken)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleGetWzFiltersData = async (filters) => {
        try {
            const res = await GetWzDocFiltersData(api, filters)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleGetOrder = async (orderId) => {
        try {
            let custId = authState.selectedCustomerData ? authState.selectedCustomerData.custId : authState.custId
            let res = await GetOrderFromView(api, orderId, custId)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    return (
        <OrderContext.Provider value={{
            orderInfo,
            selectedOrderDetails,
            setOrderInfo,
            clearOrderInfo,
            changeCustOrderNumber,
            setSelectedOrderDetails,
            handleGetOrderItems,
            handleGetOrderFiltersData,
            handleGetWzFiltersData,
            handleGetOrder,
        }}>
            {children}
        </OrderContext.Provider>
    )
}